import React from 'react';
import { Skeleton } from 'antd';

const SkeletonComponent = ({ children, ...otherProps }) => (
  <Skeleton {...otherProps}>
    {children}
  </Skeleton>
);

SkeletonComponent.defaultProps = {
  active: true,
};

export default SkeletonComponent;
